import { SVGProps } from 'react';
const SvgArrowDownUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m11 16-3 3-3-3M13 8l3-3 3 3M16 19V5M8 5v14"
    />
  </svg>
);
export default SvgArrowDownUp;
